module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAABVklEQVRYhe1XsW3DMBC8BB5A7tgpFWtZXCDeINnAGcETxJ7A2SAjeIR4AQqu1VjsVGoDBRf8G0LgBIkjykagAwRRJMU7Pv+Jf1waN+TPncsAbADcD6RnB+Cp8L6aSAfJKwDTwvsmJnPuXCJ8rwDm2tnKwCAgFzm7qtqhyDuW+OC8HZr4M0YBFxcw+Wogd2517qKF9z/+93ot8Jtd/AWjE/6vKDjHb8YoGJ3wkgKYlg0TBcHYOwB89mldNjJ3/q2APhCMzWSZBwDPAB6Dscw9KxUSLQpk12/yqfnmFkAjCfCMHdF8IK1LkuyFnO21vBM9/6gCgrFMvfUIZmldro5pOLCQ8ahRkHVMr9CaI1FxMY+Au32Rz20wdtHxibWMH0uztu+qKBjLXR5OWIFo0rqcsqEWoFNs+qyOJMyWrAE7ltD2UuepBRgyrNX6Kk53etEQpy6i6wCAd76kcY73sBhQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyfy31.png
// module id = I7dp
// module chunks = 73